import React from 'react';
import { IconButton, TextFieldProps } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { FormikValues, getIn } from 'formik';
import { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';

export const getFreezeSlotProps = (
  params: AutocompleteRenderInputParams,
  values: FormikValues,
  setFreezeDialogOpen: (open: boolean) => void
): TextFieldProps['slotProps'] => {
  return {
    input: {
      ...params.InputProps,
      endAdornment: (
        <>
          {params.InputProps?.endAdornment}
          {getIn(values, 'embryoDetails.action') === 'FREEZE' && (
            <IconButton
              onClick={() => setFreezeDialogOpen(true)}
              edge="end"
              size="small"
              sx={{ height: '20px', width: '20px' }}
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
          )}
        </>
      ),
    },
  };
};
